export interface ICreateVideoDTO {
  createVideoDto: {
    title: string;
    description: string;
    thumbnailUrl: string;
  };
}
export interface IUpdateMediaRequest {
  mediaSrcFile?: File;
  thumbnailFile?: File;
  subtitleFile?: File;
  uid: string;
  url?: string | File;
  description?: string;
  title?: string;
  subtitleUrl?: string | File;
  accessType?: MediaAccessType;
  sections?: string[];
}

export enum MediaAccessType {
  BASE = "Base",
  STORYTELLER_BASIC = "Storyteller basic",
  STORYTELLER_UNLIMITED = "Storyteller unlimited",
}

export type UpdateMediaData = IUpdateMediaRequest | FormData;

export enum Category {
  Mighty_Me = "Mighty Me",
  Mad_Scientist = "Mad Scientist",
  Number_Wizardry = " Number Wizardry",
  Reading_Wonderland = "Reading Wonderland",
  Geo_Explorers = "Geo Explorers",
}

export type IVideoWithMeta = {
  videos: IMedia[];
  total: number;
};

export type IMediaVideoWithMeta = {
  media: IMedia[];
  total: number;
};

export type IWatchedMediaWithMeta = {
  data: IMedia[];
  total: number;
};

export type IMedia = {
  accessType: string;
  description: string;
  isFavourite: boolean;
  isPublished: boolean;
  likes: number;
  subtitleUrl: string;
  thumbnailPrompt: string;
  thumbnailUrl: string;
  title: string;
  type: string;
  uid: string;
  url: string;
  viewsCount: number;
  sections: string[];
  mediaSrcFile?: File;
  thumbnailFile?: File;
  subtitleFile?: File;
};
